import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ScriptBlockConfig } from '@front-platform/content-builder';
import { scriptBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
export interface ScriptBlockRuntimeConfig {}

export type ScriptBlockConfigInput = Partial<
  Omit<ScriptBlockConfig, keyof ScriptBlockRuntimeConfig> & ScriptBlockRuntimeConfig
>;
export type ScriptBlockResolvedConfig = Omit<ScriptBlockConfig, keyof ScriptBlockRuntimeConfig> &
  Partial<ScriptBlockRuntimeConfig>;
export interface ScriptBlockContract extends ConfigComponentContract<
  ScriptBlockConfigInput,
  ScriptBlockResolvedConfig
> {}

@Component({
  template: ``,
  selector: 'app-script-block',
  standalone: false,
})
export class ScriptBlockComponent implements OnInit, ScriptBlockContract {
  readonly config = input<ScriptBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<ScriptBlockConfig, ScriptBlockRuntimeConfig>(
    scriptBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  get script(): string | undefined {
    return this.resolvedConfig()['script'] as unknown as string | undefined;
  }
  private _scriptPositionConfigOverride: string | undefined | undefined;
  get scriptPosition(): string | undefined {
    return (
      this._scriptPositionConfigOverride ??
      (this.resolvedConfig()['script_position'] as unknown as string | undefined)
    );
  }
  set scriptPosition(value: string | undefined) {
    this._scriptPositionConfigOverride = value;
  }

  constructor() {}

  ngOnInit(): void {
    if (!this.script) {
      return;
    }
    const fragment = document
      .createRange()
      .createContextualFragment('<script>' + this.script + '</script>');
    if (this.scriptPosition === 'head') {
      document.head.appendChild(fragment);
      return;
    }
    document.body.appendChild(fragment);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ScriptBlockComponent, { 'keyAliases': {} });
